import React, { useMemo } from 'react';

// helpers
import useTranslation from 'hooks/useTranslation';
import { FormInputPhoneNumberProps } from './types';
import { generateSimpleRequiredOptionalPlaceholder } from '../utils';

// components
import { InputPhoneNumber } from '@ui';

const FormInputPhoneNumber: React.FC<FormInputPhoneNumberProps> = ({
  validationRules,
  placeholder: propsPlaceholder,
  renderPlaceholder,
  ...rest
}) => {
  const { t } = useTranslation('form');

  const placeholder = useMemo(() => {
    if (propsPlaceholder) {
      return propsPlaceholder;
    }

    if (renderPlaceholder) {
      return renderPlaceholder(validationRules || []);
    }

    return generateSimpleRequiredOptionalPlaceholder(validationRules || [], t);
  }, [validationRules, propsPlaceholder, renderPlaceholder]);

  return <InputPhoneNumber {...rest} placeholder={placeholder} />;
};

export default React.memo(FormInputPhoneNumber);
